export const SignUp = {
  en: {
    Email: 'Email',
    changeEmail: 'Change email',
    createAccount: 'Create account',
    fillFormAndJoin: 'Fill out the form and join the community',
    creatingAccount: 'Creating account...',
  },
  uk: {
    Email: 'Email',
    changeEmail: 'Змінити email',
    createAccount: 'Створити акаунт',
    fillFormAndJoin: 'Заповни форму і приєднуйся до спільноти',
    creatingAccount: 'Створення акаунту...',
  },
};
